module.exports = __webpack_public_path__ + "img/arrow-down.91a9e4c2.svg";